
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/ai-usage-policy",
      function () {
        return require("private-next-pages/legal/ai-usage-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/ai-usage-policy"])
      });
    }
  